import classes from "./dashboard.module.css";
import dropdown from "../../../assets/images/dropdown.svg";
import moment from "moment";
import { Avatar, Typography, Chip, Box } from "@mui/material";
import {
  getChipColor,
  getInitialName,
} from "../../../utilities/commonFunctions";

const MemberCard = ({
  currectMember,
  setCurrentMember,
  indexVal,
  userdetails,
}) => {
  const boder = false;

  return (
    <div className={classes.memberCardContainer}>
      <div
        className={classes.member_TeamDetails}
        style={{ borderBottomWidth: boder ? "1px" : "none" }}
      >
        <div className={classes.TeamDetailsLeft}>
          <Box sx={{ position: "relative" }}>
            <Avatar
              sx={{
                bgcolor: `${userdetails?.department?.colour}`,
                width: "35px",
                height: "35px",
                fontSize: "14px",
              }}
            >
              {userdetails?.user_name
                ? getInitialName(userdetails.user_name)?.toUpperCase()
                : "NM"}
            </Avatar>
          </Box>
          <div>
            <Typography fontWeight={500} style={{ fontSize: "12px" }}>
              {userdetails?.user_name}
            </Typography>
          </div>
        </div>
        <div className={classes.TeamDetailsRight}>
          <div className={classes.TeamDetailsRightStatus}>
            <Chip
              className={classes.locationStatusChip}
              label={userdetails?.attendance_status}
              size="small"
              style={getChipColor(userdetails?.attendance_status)}
            />
          </div>
          <img
            src={dropdown}
            style={{
              cursor: "pointer",
              transform: `${
                currectMember.includes(indexVal)
                  ? "rotate(180deg)"
                  : "rotate(0deg)"
              }`,
            }}
            alt="drop_down"
            onClick={() =>
              setCurrentMember((prev) =>
                prev.includes(indexVal)
                  ? prev.filter((item) => item !== indexVal)
                  : [...prev, indexVal],
              )
            }
          />
        </div>
      </div>
      <div>
        {currectMember.includes(indexVal) ? (
          <div className={classes.Teammember_checkin}>
            <Box sx={{ position: "relative" }}>
              <Avatar
                sx={{
                  bgcolor: `white`,
                  width: "44px",
                  height: "44px",
                }}
              ></Avatar>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <Box sx={{ display: "flex", gap: "24px" }}>
                <Typography
                  fontWeight={500}
                  className={classes.checkin_heading}
                  width={"120px"}
                >
                  First Time In
                </Typography>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
                >
                  <Typography
                    fontWeight={500}
                    className={classes.checkin_details_p}
                  >
                    {userdetails?.attendance?.first?.checkIn
                      ? moment(userdetails?.attendance?.first?.checkIn).format(
                          "hh:mm A",
                        )
                      : "---"}
                  </Typography>
                  <Typography
                    fontWeight={500}
                    className={classes.checkin_details_p}
                  >
                    {userdetails?.attendance?.first?.checkIn_location}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: "24px" }}>
                <Typography
                  fontWeight={500}
                  className={classes.checkin_heading}
                  width={"120px"}
                >
                  Last Time Out
                </Typography>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
                >
                  <Typography
                    fontWeight={500}
                    className={classes.checkin_details_p}
                  >
                    {userdetails?.attendance?.last?.checkOut
                      ? moment(userdetails?.attendance?.last?.checkOut).format(
                          "hh:mm A",
                        )
                      : "---"}
                  </Typography>
                  <Typography
                    fontWeight={500}
                    className={classes.checkin_details_p}
                  >
                    {userdetails?.attendance?.last?.checkOut_location}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MemberCard;
